import type { Demo } from "./types";
import { lockstep } from "./lockstep";
import { bullets } from "./bullets";
import { breakableWall } from "./breakableWall";
import { demolition } from "./demolition";
import { pyramid } from "./pyramid";
import { stack } from "./stack";
import { dominoes } from "./dominoes";
import { bridge } from "./bridge";
import { wreckingBall } from "./wreckingBall";
import { ragdoll } from "./ragdoll";
import { machine } from "./machine";
import { elevators } from "./elevators";
import { vehicle } from "./vehicle";
import { pulley } from "./pulley";
import { gears } from "./gears";
import { newtonsCradle } from "./newtonsCradle";
import { jelly } from "./jelly";
import { plinko } from "./plinko";
import { flag } from "./flag";
import { radar } from "./radar";
import { mixedPit } from "./mixedPit";
import { shapes } from "./shapes";
import { concave } from "./concave";
import { pour } from "./pour";
import { sandbox } from "./sandbox";

/** All demos, in gallery order. */
export const demos: Demo[] = [
	lockstep,
	bullets,
	breakableWall,
	demolition,
	pyramid,
	stack,
	dominoes,
	bridge,
	wreckingBall,
	ragdoll,
	machine,
	elevators,
	vehicle,
	pulley,
	gears,
	newtonsCradle,
	jelly,
	plinko,
	flag,
	radar,
	mixedPit,
	shapes,
	concave,
	pour,
	sandbox,
];
